<main class="bg-white position-relative">
  <div class="payoutt_container">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 O-M-2">
          <div class="title_content">
            <h1 class="text-uppercase text-white open_sans font_68 bold_700 latest_new">Latest Update
            </h1>
            <p class="mt-lg-3 mt-xl-4 mt-2">We caught up professional skateboarder Jamie Foy on
              how<br/>
              he's spending time at home.</p>
            <div class="mt-lg-3 mt-xl-4">
              <a
                class="text-uppercase open_sans bold_700 text-white bg_green shop_btn d-inline-block font_16 mt-lg-2 mt-xl-3"
                routerLink="/categories-detail">Shop
                Now</a>
            </div>
          </div>
        </div>
        <div class="col-md-6 O-M-1">
          <img alt="" class="img-fluid float-right" src="/assets/images/news_shoes.png"/>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
  <!-- news-blog -->
  <div class="Blog-section">
    <div class="container">
      <div class="row">
        <div class="col-md-8">
          <div class="blog-detail-right text-left">
            <div class="blog-info">
              <img alt="images" src="/assets/images/News_01.jpg">
              <h2>Ever undertakes laborious physical</h2>
              <div class="author-info">
                <a href="javascript:void(0)">By Admin</a>
                <a href="javascript:void(0)">18 OCT 2018</a>
                <a href="javascript:void(0)">2 Comment</a>
              </div>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                Ipsum has been the industry's standard dummy text ever since the 1500s, when an
                unknown printer took a galley of type and scrambled it to make a type specimen book.
                It has survived not only five centuries, but also the leap into electronic
                typesetting, remaining essentially unchanged. It was popularised in the 1960s with
                the release of Letraset sheets containing Lorem Ipsum passages, and more recently
                with desktop publishing software like Aldus PageMaker including versions of Lorem
                Ipsum.</p>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                Ipsum has been the industry's standard dummy text ever since the 1500s, when an
                unknown printer took a galley of type and scrambled it to make a type specimen book.
                It has survived not only five centuries, but also the leap into electronic
                typesetting, remaining essentially unchanged. It was popularised in the 1960s with
                the release of Letraset sheets.</p>
            </div>
            <div class="comments">
              <h3 class="comment-heading">2 Comments</h3>
              <div class="comment-body">
                <div class="comment-right">
                  <div class="comment-img">

                  </div>
                </div>
                <div class="comment-left">
                  <h4><a href="javascript:void(0);"> David Martin</a></h4>
                  <p class="comment-date">20 OCT, 2018</p>
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                    Lorem Ipsum has been the industry's standard dummy text ever since the
                    1500s, when an unknown printer took a galley of type and scrambled</p>
                </div>
              </div>
              <div class="comment-body">
                <div class="comment-right">
                  <div class="comment-img">

                  </div>
                </div>
                <div class="comment-left">
                  <h4><a href="javascript:void(0);"> David Martin</a></h4>
                  <p class="comment-date">20 OCT, 2018</p>
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                    Lorem Ipsum has been the industry's standard dummy text ever since the
                    1500s, when an unknown printer took a galley of type and scrambled</p>
                </div>
              </div>
            </div>
            <div class="comment-form">
              <h3>Leave a comment</h3>
              <form>
                <div class="row">
                  <div class="col-md-6">
                    <input name="name" placeholder="Your Name" type="text">
                  </div>
                  <div class="col-md-6">
                    <input name="email" placeholder="Email Address" type="email">
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <textarea placeholder="Messages"></textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 submit-btn">
                    <button type="submit">Submit</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="blog-left">
            <div class="blog-search">
              <input name="Search" placeholder="search" type="text">
              <button type="submit"><i class="fa fa-search"></i></button>
            </div>
            <div class="latest-post text-left">
              <h3>Latest Posts</h3>
              <div class="latest-body">
                <div class="latest-img">
                  <img alt="images" src="/assets/images/News_02.jpg">
                </div>
                <div class="latest-info">
                  <a href="javascript:void(0);">Ever undertakes laborious physical</a>
                </div>
              </div>
              <div class="latest-body">
                <div class="latest-img">
                  <img alt="images" src="/assets/images/News_02.jpg">
                </div>
                <div class="latest-info">
                  <a href="javascript:void(0);">Ever undertakes laborious physical</a>
                </div>
              </div>
              <div class="latest-body">
                <div class="latest-img">
                  <img alt="images" src="/assets/images/News_02.jpg">
                </div>
                <div class="latest-info">
                  <a href="javascript:void(0);">Ever undertakes laborious physical</a>
                </div>
              </div>
            </div>
            <div class="latest-post tags text-left">
              <h3>Tags</h3>
              <a href="javascript:void(0);">Consulting,</a> <a
              href="javascript:void(0);">Business,</a> <a href="javascript:void(0);">Market,</a>
              <a href="javascript:void(0);">Corporate,</a> <a
              href="javascript:void(0);">Technology,</a> <a
              href="javascript:void(0);">Experts,</a> <a href="javascript:void(0);">Advicsor</a>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</main>
